module.exports = __webpack_public_path__ + "static/1-1c2812239b8d32604b056df1bf370904.jpg";